import { Action, Dispatch } from 'redux'
import { push } from 'connected-react-router'
import { db, FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { BreadType } from 'types/bread'

const deleteBread = (breadRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const batch = db.batch()
    const value: Pick<BreadType, 'status' | 'updated_at'> = { status: 'delete', updated_at: FirebaseTimestamp.now() }
    batch.update(breadRef, value)
    return batch
      .commit()
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push('/product/delete'))
      })
      .catch((error) => {
        console.error(error)
        dispatch(hideLoadingAction())
      })
  }
}

export default deleteBread
